export default __webpack_public_path__ + "assets/front/scss/recherche/astuces/styles.1c7c09daddf6eb6d5b05265c5f4e067c.css";